import type {
  EditorChoiceDataPaginationResponse,
  EditorChoicePaginationResponse,
  GenreLightSerializerWithSubgenres,
  IApiResponse,
} from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";
import { TagsType } from "../constants";

interface IEditorChoiceQueryArgs {
  art_groups?: number[];
  offset?: string;
  limit?: number;
  genre_id?: number;
}
interface IEditorChoiceGenresQueryArgs {
  art_types?: ("text_book" | "audiobook" | "podcast")[];
}

export const editorChoiceApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getEditorChoiceArts: build.query<
      EditorChoiceDataPaginationResponse,
      IEditorChoiceQueryArgs
    >({
      query: params => ({
        url: "/foundation/api/arts/editor-choice",
        params,
      }),
      transformResponse: (response: EditorChoicePaginationResponse) => {
        return response.payload;
      },
      providesTags: result =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: TagsType.ART_SHORT_LIST as const,
                id,
              })),
              TagsType.ART_SHORT_LIST,
            ]
          : [TagsType.ART_SHORT_LIST],
    }),
    getEditorChoiceGenres: build.query<
      IApiResponse<GenreLightSerializerWithSubgenres[]>["payload"],
      IEditorChoiceGenresQueryArgs
    >({
      query: params => ({
        url: "/foundation/api/arts/editor-choice/genres",
        params,
      }),
      transformResponse: (
        response: IApiResponse<GenreLightSerializerWithSubgenres[]>
      ) => {
        return response.payload;
      },
    }),
  }),
});
